import React from 'react';
import { IProps } from './interfaces';

const KrGift: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      id="Capa_1"
      width={size}
      height={size}
      className={className}
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M29.56,6.94h-4.51c.48-.75.91-1.77.78-2.87-.15-1.28-1-2.36-2.53-3.23-1.14-.64-2.25-.73-3.29-.27-2.38,1.06-3.66,4.79-4.11,6.37h-.18c-.45-1.58-1.74-5.31-4.11-6.37-1.05-.46-2.15-.37-3.29.27-1.53.86-2.38,1.95-2.53,3.23-.13,1.1.31,2.12.78,2.87H2.44C1.09,6.94,0,8.04,0,9.39v2.84c0,1.19.85,2.18,1.98,2.4-.14.34-.22.72-.22,1.12v13.36c0,1.61,1.31,2.91,2.91,2.91h22.8c1.61,0,2.91-1.31,2.91-2.91v-13.36c0-.41-.09-.79-.24-1.15,1.07-.26,1.87-1.22,1.87-2.37v-2.84c0-1.35-1.1-2.44-2.44-2.44ZM20.5,1.67c.69-.31,1.41-.23,2.22.22,1.18.66,1.83,1.44,1.93,2.32.13,1.12-.62,2.19-1.08,2.74h-6.42c.54-1.76,1.7-4.54,3.35-5.27ZM13.42,30.21v-15.54h5.27v15.54h-5.27ZM13.42,12.83v-4.09h5.27v4.09h-5.27ZM6.97,4.21c.1-.87.75-1.65,1.93-2.32.8-.45,1.53-.52,2.22-.22,1.65.73,2.81,3.51,3.35,5.27h-6.42c-.46-.54-1.22-1.62-1.08-2.74ZM1.79,9.39c0-.35.29-.64.64-.64h9.79v4.09h-7.56c-.13,0-.26.02-.39.04h-1.83c-.36,0-.64-.29-.64-.64v-2.84ZM3.55,29.1v-13.36c0-.54.4-.98.92-1.07h7.76v15.54h-7.56c-.61,0-1.11-.5-1.11-1.11ZM28.57,29.1c0,.61-.5,1.11-1.11,1.11h-7.56v-15.54h7.76c.52.1.92.53.92,1.07v13.36ZM30.21,12.23c0,.35-.29.64-.64.64h-1.71c-.13-.02-.26-.04-.39-.04h-7.56v-4.09h9.67c.36,0,.64.29.64.64v2.84Z"
      />
    </svg>
  );
};

export default KrGift;
